/* Naturbly — animations runtime
   - Scroll reveals via IntersectionObserver
   - Counter animations ([data-counter] met numerieke of X% / €X content)
   - Stagger auto: geen data-reveal-delay nodig als ouder data-reveal-stagger heeft
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Scroll reveal ----------
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---------- Auto-stagger children ----------
  function initStagger() {
    var groups = document.querySelectorAll('[data-reveal-stagger]');
    groups.forEach(function (g) {
      var children = g.children;
      for (var i = 0; i < children.length; i++) {
        if (!children[i].hasAttribute('data-reveal')) {
          children[i].setAttribute('data-reveal', '');
        }
        if (!children[i].hasAttribute('data-reveal-delay') && i < 6) {
          children[i].setAttribute('data-reveal-delay', String(i + 1));
        }
      }
    });
  }

  // ---------- Counter animation ----------
  // Usage: <span data-counter="960">0</span> or <span data-counter="€230">€0</span>
  function animateCount(el) {
    var raw = el.getAttribute('data-counter') || el.textContent.trim();
    // Parse optional prefix/suffix (non-digit chars)
    var m = raw.match(/^([^\d-]*)([\d.,]+)(.*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var isFloat = numStr.indexOf(',') > -1 || numStr.indexOf('.') > -1;
    var target = parseFloat(numStr.replace('.', '').replace(',', '.'));
    if (isNaN(target)) return;
    var duration = 1400, start = null;
    function render(t) {
      if (!start) start = t;
      var pct = Math.min(1, (t - start) / duration);
      // Ease-out cubic
      var eased = 1 - Math.pow(1 - pct, 3);
      var value = target * eased;
      var formatted;
      if (isFloat) {
        formatted = value.toFixed(1).replace('.', ',');
      } else {
        formatted = Math.round(value).toString();
      }
      el.textContent = prefix + formatted + suffix;
      if (pct < 1) requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      // No animation; just leave content as-is
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCount(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      el.textContent = '0';
      io.observe(el);
    });
  }

  // ---------- Boot ----------
  function boot() {
    initStagger();
    initReveal();
    initCounters();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
